export default __webpack_public_path__ + "static/media/blockMobile.ce6aed2c.png";